module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/logo_main-704ea277fa2aeeaeb7ccad0bbaab3eab.svg";